import React from 'react';
import { BlogList } from 'patterns/BlogList';
import { Masthead } from 'patterns/Masthead';
import { Shell } from 'patterns/Shell';

import '../scss/main.scss';

function ArticleListingPage({
    location: {
        pathname,
    },
}) {
    const data = {
        masthead: {
            description: [
                {
                    spans: [],
                    text: 'Updates on how my freelance journey is going.',
                    type: 'paragraph',
                },
            ],
            title: 'Articles',
        },
        blog: {
            items: [
                {
                    card_date: '31 Dec, 2020',
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 1024,
                            width: 768,
                        },
                        url: 'https://images.prismic.io/robsimpson/40f4ac05-edfe-4a78-a70f-7900bb8bdce6_year-in-review.png?auto=compress,format'
                    },
                    card_link_url: {
                        link_type: 'Document',
                        uid: 'articles/2020-year-in-review',
                    },
                    card_title: {
                        text: '2020 year in review',
                    },
                },
                {
                    card_date: '16 Aug, 2020',
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 3024,
                            width: 4032,
                        },
                        url: 'https://images.prismic.io/robsimpson/b654c40f-f586-4b69-8fdb-9ff3018fa444_about-office.jpg?auto=compress,format'
                    },
                    card_link_url: {
                        link_type: 'Document',
                        uid: 'articles/full-time-freelance-designer-developer',
                    },
                    card_title: {
                        text: 'Starting a new chapter as a full time freelancer',
                    },
                },
            ],
        },
    };

    return (
        <Shell
            pageDescription="Sharing my insights into the world of freelance web design and development."
            pageSocialImage=""
            pageTitle="Articles"
            pathname={pathname}
        >
            <Masthead
                description={data.masthead.description}
                title={data.masthead.title}
            />
            <BlogList
                items={data.blog.items}
            />
        </Shell>
    );
}

export default ArticleListingPage;
